module.exports = __webpack_public_path__ + "img/phone.1d344979.png";